import { __extends } from "tslib";
import { UpdateApnsVoipSandboxChannelRequest, UpdateApnsVoipSandboxChannelResponse } from "../models/index";
import { deserializeAws_restJson1UpdateApnsVoipSandboxChannelCommand, serializeAws_restJson1UpdateApnsVoipSandboxChannelCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateApnsVoipSandboxChannelCommand = /** @class */ (function (_super) {
    __extends(UpdateApnsVoipSandboxChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateApnsVoipSandboxChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateApnsVoipSandboxChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: UpdateApnsVoipSandboxChannelRequest.filterSensitiveLog,
            outputFilterSensitiveLog: UpdateApnsVoipSandboxChannelResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateApnsVoipSandboxChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1UpdateApnsVoipSandboxChannelCommand(input, context);
    };
    UpdateApnsVoipSandboxChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1UpdateApnsVoipSandboxChannelCommand(output, context);
    };
    return UpdateApnsVoipSandboxChannelCommand;
}($Command));
export { UpdateApnsVoipSandboxChannelCommand };
//# sourceMappingURL=UpdateApnsVoipSandboxChannelCommand.js.map